@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  <!-- <span *ngIf="$.row[$.adata.keyName]">{{splitCapitalCase($.row[$.adata.keyName])}}</span> -->
  @if ($.row[$.adata.keyName]) {
    <span>{{ 'TRANSFER.' + $.row[$.adata.keyName] | translate }}</span>
  }
}
